module.exports = __webpack_public_path__ + "static/media/rugrats-post-game-socks.e27440bc.png";